import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-center">
            <div className="newsletter">
              <span className="newsletter-title">Newsletter</span>
              <input
                type="text"
                name="email"
                className="newsletter-input"
                placeholder="Enter your email to join our newsletter"
                required
              />
              <button className="newsletter-submit">Sign Up</button>
            </div>
            <div className="socials">
              <a href>
                <i className="fab fa-facebook-f" />
              </a>
              <a href>
                <i className="fab fa-twitter" />
              </a>
              <a href>
                <i className="fab fa-snapchat-ghost" />
              </a>
              <a href>
                <i className="fab fa-pinterest-p" />
              </a>
              <a href>
                <i className="fab fa-instagram" />
              </a>
              <a href>
                <i className="fab fa-youtube" />
              </a>
              <a href>
                <i className="fab fa-tumblr" />
              </a>
            </div>
          </div>
        </div>
        <div className="row u-padding-bottom-m u-display-block-responsive-1080">
          <div className="col-1-of-2">
            <div className="row padding-0">
              <div className="col-1-of-3">
                <h3 className="footer-title">Company</h3>
                <ul className="footer-list">
                  <li className="footer-list-item">
                    <a href>About</a>
                  </li>
                  <li className="footer-list-item">
                    <a href>Contact Us</a>
                  </li>
                  <li className="footer-list-item">
                    <a href>Careers</a>
                  </li>
                </ul>
              </div>
              <div className="col-1-of-3">
                <h3 className="footer-title">Customer Service</h3>
                <ul className="footer-list">
                  <li className="footer-list-item">
                    <a href>Support</a>
                  </li>
                  <li className="footer-list-item">
                    <a href>Find A Dealer</a>
                  </li>
                  <li className="footer-list-item">
                    <a href>Repair Centers</a>
                  </li>
                  <li className="footer-list-item">
                    <a href>Warranty Info</a>
                  </li>
                  <li className="footer-list-item">
                    <a href>Subscribe</a>
                  </li>
                  <li className="footer-list-item">
                    <a href>FAQ</a>
                  </li>
                </ul>
              </div>
              <div className="col-1-of-3">
                <h3 className="footer-title">More from Fender</h3>
                <ul className="footer-list">
                  <li className="footer-list-item">
                    <a href>Electric Guitars</a>
                  </li>
                  <li className="footer-list-item">
                    <a href>Stratocaster</a>
                  </li>
                  <li className="footer-list-item">
                    <a href>Telecaster</a>
                  </li>
                  <li className="footer-list-item">
                    <a href>Guitar Amplifiers</a>
                  </li>
                  <li className="footer-list-item">
                    <a href>Basses</a>
                  </li>
                  <li className="footer-list-item">
                    <a href>Acoustic Guitars</a>
                  </li>
                  <li className="footer-list-item">
                    <a href>Fender Play</a>
                  </li>
                  <li className="footer-list-item">
                    <a href>Fender Tone</a>
                  </li>
                  <li className="footer-list-item">
                    <a href>Tone App</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-1-of-2 float-right u-flex-column footer-right footer-details">
            <div className="row u-display-block padding-0">
              {/* <div class="region">Change your region:
                            <a href="" class="country">
                                <span class="flag flag-au"></span> Australia
                            </a>
                        </div> */}
              <div className="footer-logo">
                <a href>
                  <i className="fdr-icon fdr-icon--logo" />
                </a>
              </div>
              <div className="imprint">
                <p>Copyright ©2019. Fender Musical Instruments Corporation.</p>
                <p>All Rights Reserved.</p>
              </div>
            </div>
            <div className="row u-display-block padding-0">
              <div className="region">
                Change your region:
                <a href className="country">
                  <span className="flag flag-au" /> Australia
                </a>
              </div>
              <ul className="imprint-links">
                <li className="imprint-links-item">
                  <a href>Privacy Policy</a>
                </li>
                <li className="imprint-links-item">
                  <a href>Terms &amp; Conditions</a>
                </li>
                <li className="imprint-links-item">
                  <a href>Supply Chain Transparency</a>
                </li>
                <li className="imprint-links-item">
                  <a href>Modern Slavery Act 2019</a>
                </li>
                <li className="imprint-links-item">
                  <a href>Accessibility Statement</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
